<template lang="pug">
  #app
    app-header
    main.main
      router-view
    app-footer
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    AppHeader: Header,
    AppFooter: Footer
  },
  mounted () {
  }
}
</script>

<style lang="sass">
  @import '@/sass/main.sass'
</style>



// WEBPACK FOOTER //
// src/App.vue